export default __webpack_public_path__ + "static/mbanner2-0dc95e4af552d4a940346c668995eec4.png";